import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "./trpc.js";

/** The signed-in manager, or null. Cached for the whole session. */
export function useSession() {
  const trpc = useTRPC();
  const query = useQuery(
    trpc.auth.me.queryOptions(undefined, { staleTime: 5 * 60_000 }),
  );
  return {
    user: query.data ?? null,
    isLoading: query.isLoading,
    isCommissioner: query.data?.role === "commissioner",
  };
}

export function useLogout() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  return useMutation(
    trpc.auth.logout.mutationOptions({
      onSuccess: () => {
        // Everything on the site can depend on who you are, so drop it all.
        queryClient.clear();
      },
    }),
  );
}
